module.exports = __webpack_public_path__ + "img/orange_dance.372b0706.png";